import columnsDefaultStyles from '@/constants/toolbarEditorOptions/columnsDefaultStyles'
import {forEach, get} from 'lodash'

export default {
  methods: {
    setTableDefaultStyle (content) {
      const htmlContent = document.createElement('div')
      htmlContent.innerHTML = content
      const tdCollection = htmlContent.getElementsByTagName('TD')
      if (tdCollection.length === 0) return content
      forEach(tdCollection, td => {
        columnsDefaultStyles.forEach(style => {
          const styleValue = get(td, ['style', style.name], '')
          if (!styleValue) td.style[style.name] = style.value
        })
      })
      return htmlContent.innerHTML
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setTableDefaultStyle.js